<!--正负数值 格式化为 红+ 绿- -->
<template>
  <span class="number-color" v-html="str" />
</template>

<script>
export default {
  props: {
    number: {
      type: [String, Number],
      required: true
    },
    colorful: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      n: ''
    }
  },
  computed: {
    str() {
      let n = parseFloat(this.number)
      let str = ''
      if (n > 0) {
        str = `<span class="${this.colorful ? 'c-green-2' : ''}">+${n}</span>`
      } else if (n < 0) {
        str = `<span class="${this.colorful ? 'c-red' : ''}">${n}</span>`
      } else {
        str = `<span>${n}</span>`
      }
      return str
    }
  },
  created() {
  }
}

</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
